import { ChatToggle } from "./chat-toggle";
import { ParticipantScreenSharingToggle } from "./participant-screen-sharing-toggle";
import { RaisedHandSoundToggle } from "./raised-hand-sound-toggle";

export function CallSettings() {
  return (
    <div className="space-y-4">
      <ParticipantScreenSharingToggle />
      <ChatToggle />
      <RaisedHandSoundToggle />
    </div>
  );
}
